// src/constants/constants.js
export const NAVBAR_HEIGHT = 130; // px
export const TOP_APP_BAR_HEIGHT = 70; //px
export const BOTTOM_NAV_BAR_HEIGHT = 60; // px
export const BOTTOM_ACTION_BUTTONS_POSITION = 80; // px
export const TOP_AUTOCOMPLETE_ICON_POSITION = 86; // px
export const MESSAGE_TABS_POSITION = 90; // px
export const SCROLLABLE_MESSAGE_LIST_POSITION = 90; // px
export const SCROLLABLE_MESSAGE_LIST_HEIGHT_OFFSET = 220; // px
export const US_RATINGS = ["G", "PG", "PG-13", "R", "M"];
export const TV_CATEGORIES = [
  "Drama",
  "Comedy",
  "Reality",
  "News",
  "Sports",
  "Documentary",
];
